export function executeLink(href: string, target: string | undefined = '_blank') {
  const anchorElement = document.createElement('a');
  document.body.appendChild(anchorElement);
  anchorElement.href = href;
  anchorElement.target = target;
  anchorElement.rel = 'noopener noreferrer';
  anchorElement.click();
  anchorElement.remove();
}
